// A store's licenses for order documents (EN-196). Mirrors storeLicenseEntries in the admin
// portal's shared/constants/marketTypes.js, which is unit-tested. Markets are OptMarketTypes
// (1 Medical / 2 Recreational) — the same ids as an order's OptInvoiceTypeID.
const MARKET_NAMES = { 1: 'Medical', 2: 'Recreational' };

/**
 * "Label: Number" entries. The market is named only where the store holds that label in more
 * than one market ("M.E.D. – Recreational"); `invoiceMarket` keeps a split Medical / Recreational
 * invoice to that market's licenses (untagged licenses always show).
 */
export function storeLicenseEntries(clientLicenses, labelName, { invoiceMarket = null } = {}) {
  const marketsByLabel = new Map();
  clientLicenses.forEach((l) => {
    if (!l.optMarketTypeID) return;
    marketsByLabel.set(l.license, (marketsByLabel.get(l.license) || new Set()).add(Number(l.optMarketTypeID)));
  });
  return clientLicenses
    .filter((l) => !invoiceMarket || !l.optMarketTypeID || Number(l.optMarketTypeID) === Number(invoiceMarket))
    .map((l) => {
      const name = labelName(l.license) || '';
      const market = MARKET_NAMES[Number(l.optMarketTypeID)];
      const named = marketsByLabel.get(l.license)?.size > 1 && market;
      return { label: named ? `${name} – ${market}` : name, number: l.number || '' };
    });
}
